<template>
    <div class="attach-file-wrapper">
        <input type="file" :multiple="multiple" class="file-attachment-btn" ref="fileInput" @change="filesSelected" />
        <button class="widget-btn file-ui-btn" @click.prevent="openFileBrowser">+ Add Files</button>
    </div>
</template>

<script>
    export default {
        props: ["multiple", "bus"],
        mounted: function() {
            this.bus.on("openFileBrowser", this.openFileBrowser);
            this.bus.on("removeAllFiles", this.resetFileInput);
        },
        beforeUnmount: function() {
            this.bus.off("openFileBrowser", this.openFileBrowser);
            this.bus.off("removeAllFiles", this.resetFileInput);
        },
        methods: {
            openFileBrowser: function () {
                this.$refs.fileInput.click();
            },
            filesSelected: function (e) {
                this.bus.emit("filesSelected", this.$refs.fileInput.files);
            },
            resetFileInput: function (except) {
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = "";
                }
            }
        }
    }
</script>